<!-- login-modal.component.html -->
<ion-header class="modal-header">
  <ion-toolbar class="header-toolbar">
    <div class="header-content">
      <div class="header-text">
        <h2 class="modal-title">{{ "login.login_to_continue" | translate }}</h2>
        <p class="modal-subtitle" *ngIf="infoMessage">{{ infoMessage }}</p>
      </div>
      <ion-button fill="clear" (click)="dismiss(false)" class="close-btn">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="modal-content">
  <div>
    <ion-grid class="ion-no-padding">
      <ion-row
        class="ion-no-padding ion-no-margin ion-justify-content-center ion-align-items-center"
        style="height: 100%; flex-direction: column"
      >
        <div style="width: 95%">
          <ion-card
            class="input-container no-shadow mart0"
            *ngIf="!showOTPInput"
          >
            <form [formGroup]="formGrp" novalidate class="formCls">
              <p class="font600 message2 black-text-color fs-5">
                {{ (loginMode === 'email' ? "Enter your email" : "Enter your mobile number") | translate }}
              </p>
              <!-- Mobile / Email toggle -->
              <ion-segment
                [(ngModel)]="loginMode"
                [ngModelOptions]="{ standalone: true }"
                (ionChange)="onLoginModeChange($event)"
                class="custom-segment login-mode-segment marb16"
                mode="ios"
              >
                <ion-segment-button value="mobile">
                  <div class="d-flex">
                    <ion-icon name="phone-portrait-outline"></ion-icon>
                    <ion-label>Mobile</ion-label>
                  </div>
                </ion-segment-button>
                <ion-segment-button value="email">
                  <div class="d-flex">
                    <ion-icon name="mail-outline"></ion-icon>
                    <ion-label>Email</ion-label>
                  </div>
                </ion-segment-button>
              </ion-segment>
              <!-- Mobile login -->
              <ng-container *ngIf="loginMode === 'mobile'">
                <div class="d-flex input-border ion-align-items-center">
                  <ion-button
                    (click)="selectCountryCode()"
                    mode="ios"
                    class="fs-3 width100 ion-no-margin ion-no-padding clear-btn padl10"
                  >
                    {{ selectedCountryCode.flag }}
                    {{ selectedCountryCode.dialCode }}
                    <ion-icon
                      class="fs-4 primary-icon-color"
                      name="chevron-down-outline"
                    ></ion-icon>
                  </ion-button>
                  <ion-input
                    type="tel"
                    aria-label="mobile no"
                    formControlName="mobNo"
                    placeholder="{{ 'login.enter_your_mobile_no' | translate }}"
                    class="primary-input mobile-input fs-4"
                    (ionFocus)="onInputFocus($event)"
                  >
                  </ion-input>
                </div>
                <div
                  class="show-error ion-text-center ion-margin-bottom fs-2"
                  *ngIf="
                    formGrp.get('mobNo').hasError('pattern') &&
                    formGrp.get('mobNo').dirty
                  "
                >
                  <div *ngIf="formGrp.get('mobNo').hasError('pattern')">
                    {{ "login.enter_valid_mobile_no" | translate }}
                  </div>
                </div>
              </ng-container>
              <!-- Email login -->
              <ng-container *ngIf="loginMode === 'email'">
                <div class="d-flex input-border ion-align-items-center">
                  <ion-input
                    type="email"
                    aria-label="email"
                    formControlName="email"
                    placeholder="Enter your email"
                    class="primary-input mobile-input fs-4"
                    (ionFocus)="onInputFocus($event)"
                  >
                  </ion-input>
                </div>
                <div
                  class="show-error ion-text-center ion-margin-bottom fs-2"
                  *ngIf="
                    formGrp.get('email').hasError('email') &&
                    formGrp.get('email').dirty
                  "
                >
                  <div *ngIf="formGrp.get('email').hasError('email')">
                    Please enter valid email
                  </div>
                </div>
              </ng-container>
              <p class="font600 secondary-color fs-3">
                {{ "We’ll send you an OTP to verify" | translate }}
              </p>

              <ion-button
                [disabled]="!formGrp.valid"
                (click)="sendOtpHandler()"
                mode="ios"
                expand="block"
                class="primary-btn fs-4 font500"
              >
                {{ "login.login_register_btn" | translate }}
              </ion-button>
            </form>
          </ion-card>
          <ion-card class="input-container no-shadow" *ngIf="showOTPInput">
            <ion-card-title class="font600 black-text-color enter-otp-text">{{
              "login.enter_otp_label" | translate
            }}</ion-card-title>
            <ion-item class="edit-phone" lines="none">
              <ion-label class="black-text-color fs-3 font500">
                Sent to :
                {{ otpChannel === 'email' ? formGrp.value.email :
                selectedCountryCode.dialCode + ' ' + formGrp.value.mobNo
                }}</ion-label
              >
              <ion-button
                (click)="showOTPInput = false"
                expand="block"
                class="white-btn edit-btn fs-3 font500"
              >
                {{ "login.edit_btn" | translate }}
              </ion-button>
            </ion-item>
            <ion-text
                color="success"
                class="ion-text-center"
              >
              <p class="ion-no-margin marb10">{{(otpChannel === 'email' ? "login.OTP_sent_via_email" : "login.OTP_sent_via_WhatsApp_SMS") | translate}}</p>
            </ion-text>
            <form [formGroup]="formGrp2" novalidate class="formCls">
              <ion-input
                type="number"
                aria-label="otp"
                maxlength="4"
                formControlName="otp"
                placeholder="{{ 'login.please_enter_4_digit_OTP' | translate }}"
                class="ion-padding primary-input fs-4 otp-input"
                (ionFocus)="onInputFocus($event)"
              >
              </ion-input>
              <ion-text
                color="danger"
                class="ion-text-center"
                *ngIf="showOTPError"
              >
                <p>{{ "login.invalid_otp_label" | translate }}</p>
              </ion-text>
              <ion-button
                [disabled]="!formGrp2.valid"
                (click)="verifyOTP()"
                mode="ios"
                expand="block"
                class="primary-btn fs-4 font500 mart10"
              >
                {{ "login.continue_btn" | translate }}
              </ion-button>
              <ion-button
                (click)="sendOtpHandler()"
                class="ion-margin-top white-btn fs-4 font500 border-r10 reset-btn"
                expand="block"
              >
                {{ "login.resend_otp_btn" | translate }}
              </ion-button>
            </form>
          </ion-card>
          <p class="font400 fs-3 policy-text">
            By logging in you agree to our
            <span
              class="font700 cursor-pointer"
              (click)="openTermsAndConditions()"
              >Term & conditions</span
            >
            and
            <span
              class="font700 cursor-pointer"
              (click)="openPrivacyPolicy()"
              >{{ "Privacy policy" | translate }}</span
            >
          </p>
        </div>
      </ion-row>
    </ion-grid>
  </div>

  <ion-footer class="ion-no-border">
    <ion-toolbar class="ion-text-center">
      <ion-text class="fs-4 secondary-color">
        <span>{{ appName }}</span>
        {{ "login.powered_by_label" | translate }}
      </ion-text>
    </ion-toolbar>
  </ion-footer>
</ion-content>
